import SendPaymentsThemeWrapper from './SendPaymentsTheme';

export { SendPaymentsThemeWrapper };
